/**
 * Created by jv on 2019-10-01 (14:21).
 */
require("slick-carousel/slick/slick.scss");
require("slick-carousel/slick/slick-theme.scss");

const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

import "slick-carousel/slick/slick";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");
const ArrowShortSvg = require("!raw-loader!Images/icons/btn_arrow_short.svg");
const TutorialImages = require.context("Images/tutorial", false, /\.(jpe?g|png)$/);

require("Styles/components/business-model-dialog.scss");
require("Styles/components/slider-dialog.scss");
require("Styles/components/tutorial-dialog.scss");

const tutorialSteps = [
  {
    step: 1,
    text: () => LanguageManager.getValueForKey("serious_game.business_model.tutorial.dialog.steps.0.text"),
    image: "tutorial1.png",
    alt: ""
  },
  {
    step: 2,
    text: () => LanguageManager.getValueForKey("serious_game.business_model.tutorial.dialog.steps.1.text"),
    image: "tutorial2.png",
    alt: ""
  },
  {
    step: 3,
    text: () => LanguageManager.getValueForKey("serious_game.business_model.tutorial.dialog.steps.2.text"),
    image: "tutorial3.png",
    alt: ""
  },
  {
    step: 4,
    text: () => LanguageManager.getValueForKey("serious_game.business_model.tutorial.dialog.steps.3.text"),
    image: "tutorial4.png",
    alt: ""
  },
  {
    step: 5,
    text: () => LanguageManager.getValueForKey("serious_game.business_model.tutorial.dialog.steps.4.text"),
    image: "tutorial5.png",
    alt: ""
  },
  {
    step: 6,
    text: () => LanguageManager.getValueForKey("serious_game.business_model.tutorial.dialog.steps.5.text"),
    image: "tutorial6.png",
    alt: ""
  },
  {
    step: 7,
    text: () => LanguageManager.getValueForKey("serious_game.business_model.tutorial.dialog.steps.6.text"),
    image: "tutorial7.png",
    alt: ""
  },
  {
    step: 8,
    text: () => LanguageManager.getValueForKey("serious_game.business_model.tutorial.dialog.steps.7.text"),
    image: "tutorial8.png",
    alt: ""
  }
];

class TutorialDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("tutorial-dialog-");

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog slider-dialog tutorial-dialog'>" +
      "<div class='modal-content'>" +
      //
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    if (utils.isNull(tutorialSteps)) return;

    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up tutorial dialog - %o", tutorialSteps);

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      let $tutorialContent = $("<div class='tutorial-dialog__content'></div>");

      // Dialog top
      let $tutorialTop = $("<div class='tutorial__top'></div>");

      $tutorialTop.append(`<h5 class='tutorial-dialog__title'>${LanguageManager.getValueForKey("serious_game.business_model.tutorial.dialog.title")}</h5>`);

      let $sliderPrevBtn = $(`<button class="btn btn-slider btn-slider__prev slider-dialog__prev-btn" type="button">${ArrowShortSvg}</button>`);
      let $sliderNextBtn = $(`<button class="btn btn-slider btn-slider__next slider-dialog__next-btn" type="button">${ArrowShortSvg}</button>`);
      let $imageSlider = $("<div class='tutorial-dialog__image-slider'></div>");

      $tutorialTop.append($sliderPrevBtn);
      $tutorialTop.append($imageSlider);
      $tutorialTop.append($sliderNextBtn);

      // Dialog bottom
      let $tutorialBottom = $("<div class='tutorial__bottom'></div>");

      let $contentSlider = $("<div class='tutorial-dialog__content-slider'></div>");
      $tutorialBottom.append($contentSlider);

      for (let i = 0; i < tutorialSteps.length; i++) {
        let step = tutorialSteps[i];

        let $tutorialImage = $("<div class='tutorial-step__image'></div>");
        $tutorialImage.append(`<figure><img src="${TutorialDialog.getTutorialStepImage(step)}" alt="${step.alt}"/></figure>`);
        $imageSlider.append($tutorialImage);

        let $tutorialStepContent = $("<div class='tutorial-step__content'></div>");
        $tutorialStepContent.html(step.text());
        $contentSlider.append($tutorialStepContent);
      }

      $tutorialContent.append($tutorialTop).append($tutorialBottom);
      $dialogContent.append($tutorialContent);

      this.setUpSlick();

      this.setUpEventListeners();
    }
  }

  show() {
    this.renderDialogContent();
    this.$dialog.modal("show");

    let $imageSlider = this.$dialog.find(".tutorial-dialog__image-slider");
    let $contentSlider = this.$dialog.find(".tutorial-dialog__content-slider");
    $imageSlider.slick("resize");
    $imageSlider.slick("setPosition");
    $contentSlider.slick("resize");
    $contentSlider.slick("setPosition");
  }

  hide() {
    this.$dialog.modal("hide");
  }

  setUpEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });
  }

  setUpSlick() {
    let $imageSlider = this.$dialog.find(".tutorial-dialog__image-slider");
    let $contentSlider = this.$dialog.find(".tutorial-dialog__content-slider");

    let slickOptionsDefault = {
      focusOnSelect: false,

      mobileFirst: true,

      draggable: false,
      swipe: true,

      infinite: false,

      // dots: true,
      arrows: true,
      prevArrow: this.$dialog.find(".slider-dialog__prev-btn"),
      nextArrow: this.$dialog.find(".slider-dialog__next-btn"),

      slidesToShow: 1,
      slidesToScroll: 1,

      // Without this, adding slides after the initialize is fcked up for some reason:
      // https://github.com/kenwheeler/slick/commit/be0d17cc858fb30e6a4d6b28cc29860c7170040d#comments
      rows: 0
    };

    let imageSliderOptions = {
      ...slickOptionsDefault,
      asNavFor: $contentSlider
    };

    let contentSliderOptions = {
      ...slickOptionsDefault,
      arrows: false,
      dots: true,
      appendDots: this.$dialog.find(".modal-content"),
      asNavFor: $imageSlider
    };

    $imageSlider.slick(imageSliderOptions);
    $contentSlider.slick(contentSliderOptions);
  }

  static getTutorialStepImage(step) {
    if (utils.isNull(step) || utils.isNull(step.image)) return null;
    let requireKey = `./${step.image}`;
    if (!TutorialImages.keys().includes(requireKey)) return null;

    return TutorialImages(requireKey);
  }
}

export default TutorialDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/tutorial-dialog.js